var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home clearfix"},[_c('Banner'),_c('div',{staticClass:"container"},[_c('div',{staticClass:"row-1"},[_c('Nav')],1),_c('div',{staticClass:"row-2"},[_c('RouterView')],1),_c('div',{staticClass:"row-3"},[_c('Footer')],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }